import React, { PureComponent } from 'react'
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';

import tagsConfigHelper from '../../../helpers/tagsConfigHelper'

class Tablecell extends PureComponent {
    constructor(props) {
        super(props)

        this.state ={}
        this.initState=this.initState.bind(this)
        this.initControl = this.initControl.bind(this)

        this.initState()
    }

    initState(){
        this.state={
            visible:false
        }
    }

    initControl() {
        let {doctype,tagid}=this.props
        if (!doctype || !tagid || tagid === "") return

        var tagInfo = tagsConfigHelper.findTagConfig(tagid, doctype)

            if(tagInfo){
                this.setState({
                    visible:tagInfo.visibled
                })
            }
    }

    componentWillReceiveProps(nextProps) {        
        if (this.props.doctype !== nextProps.doctype) {
               this.initControl()
        }
    }

    componentDidMount() {
        this.initControl()
    }

    render() {
        let { visible } = this.state

        if (this.props.doctype) {
            var tagInfo = tagsConfigHelper.findTagConfig(this.props.tagid, this.props.doctype)
            if (tagInfo) {
                visible = tagInfo.visibled
            }
        }
        return (
            <TableCell
                {...this.props}
                //style={{ visibility: visible ? "visible" : "hidden" }}
                style={{ display: visible ? "" : "none" , width: this.props.width}}
            />
        )
    }    
}

Tablecell.defaultProps = {
}

Tablecell.propTypes = {
    doctype: PropTypes.string,
    tagid: PropTypes.string
}

export default Tablecell